import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  ReactNode
} from 'react'

interface BannerContextType {
  isBannerVisible: boolean
  dismissBanner: () => void
}

const BannerContext = createContext<BannerContextType | undefined>(undefined)

export const useBanner = () => {
  const context = useContext(BannerContext)
  if (!context) {
    throw new Error('useBanner must be used within a BannerProvider')
  }
  return context
}

interface BannerProviderProps {
  children: ReactNode
}

export const BannerProvider = ({ children }: BannerProviderProps) => {
  const [isBannerVisible, setIsBannerVisible] = useState(false)

  useEffect(() => {
    const dismissed = localStorage.getItem('bannerDismissed_2025_conference')
    if (dismissed !== 'true') {
      setIsBannerVisible(true)
    }
  }, [])

  const dismissBanner = () => {
    setIsBannerVisible(false)
    localStorage.setItem('bannerDismissed_2025_conference', 'true')
  }

  return (
    <BannerContext.Provider value={{ isBannerVisible, dismissBanner }}>
      {children}
    </BannerContext.Provider>
  )
}
